var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-tiles"},_vm._l((_vm.plugins),function(plugin,n){return _c('Item',{key:n,staticClass:"grid-tile",attrs:{"item":plugin}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }